// Simplified equivalent of lodash's _.keyBy
// https://lodash.com/docs/#keyBy
const groupBy = <T>(arr: T[], key: string): Record<string, T[]> => arr.reduce((acc, cur) => {
  (acc[cur[key]] = acc[cur[key]] || []).push(cur);
  return acc;
}, {});

export { groupBy }
